<template lang="html">
    <div>
        <div id='vue-tag-cloud' class='vue-tag-cloud' :style='cssVars'></div>
    </div>
</template>

<script>
    const WEIGHTS_LENGTH = 10;

    export default {
        props: {
            data: {
                type: Array
            },
            options: {


            }
        },
        watch: {
            data: {
                handler: function (newVal) {
                    this.computeCloud(newVal)
                },
                deep: true
            },
            options: {
                handler: function () {
                    this.computeCloud(this.data)
                },
                deep: true
            },
        },
        data() {
            return {
                mounted: false,
                counter: 0,
                word_array: null,
                cloud_namespace: Math.floor(Math.random() * 1000000).toString(36),
                cloudOptionsDefault: {
                    width: 300,
                    height: 300,
                    shape: false,
                    removeOverflowing: false,
                    weights: 0,
                    valueExpr: 'weight',
                    nameExpr: 'text',
                    colors: ['#609fbb', '#bc594a', '#325c70', '#edc75c', '#b33873', '#b1ddcc'],
                },
                width: 0,
                height: 0,
                already_placed_words: []
            };
        },
        computed: {
            cloudOptions() {
                var result = { ...this.cloudOptionsDefault, ...this.options }
                result.center = {
                    x: this.width / 2.0,
                    y: this.height / 2.0,
                }
                return result
            },
            cssVars: function () {

                return {
                    '--cloudWidth': this.width + "px",
                    '--cloudHeight': this.height + "px",
                };
            }

        },
        mounted() {
            this.mounted = true
            this.computeCloud(this.data)
        },
        methods: {
            tagClick(tag, word) {
                this.$emit('tagClicked', {tag, word})
            },
            computeCloud(wordList) {
                if (this.mounted && wordList && wordList.length > 0 && this.cloudOptions) {
                    this.word_array = wordList
                    this.width = this.cloudOptions.width
                    this.height = this.cloudOptions.height
                    if (!this.width || this.width == "auto") {
                        var e = document.getElementById("vue-tag-cloud")
                        if (e) {
                            this.width = e.parentElement.clientWidth
                        }
                    }
                    document.getElementById("vue-tag-cloud").replaceChildren()
                    wordList.forEach((elem, index) => this.drawOneWord(index, elem))
                }
            },
            hitTest(elem, other_elems) {
                // Pairwise overlap detection
                var overlapping = function (a, b) {
                    if (
                        Math.abs(
                            2.0 * a.offsetLeft +
                            a.offsetWidth -
                            2.0 * b.offsetLeft -
                            b.offsetWidth
                        ) <
                        a.offsetWidth + b.offsetWidth
                    ) {
                        if (
                            Math.abs(
                                2.0 * a.offsetTop +
                                a.offsetHeight -
                                2.0 * b.offsetTop -
                                b.offsetHeight
                            ) <
                            a.offsetHeight + b.offsetHeight
                        ) {
                            return true;
                        }
                    }
                    return false;
                };
                var i = 0;
                // Check elements for overlap one by one, stop and return false as soon as an overlap is found
                for (i = 0; i < other_elems.length; i++) {
                    if (overlapping(elem, other_elems[i])) {
                        return true;
                    }
                }
                return false;
            },
            drawOneWord(index, word) {
                // Define the ID attribute of the span that will wrap the word, and the associated jQuery selector string
                //var word_id = this.cloud_namespace + "_word_" + index,
                //word_selector = "#" + word_id,
                var angle = 6.28 * Math.random(),
                    radius = 0.0,
                    // Only used if option.shape == 'rectangular'
                    //steps_in_direction = 0.0,
                    //quarter_turns = 0.0,
                    weight = 5,
                    //custom_class = "",
                    //inner_html = "",
                    word_span;

                // Check if min(weight) > max(weight) otherwise use default
                if (
                    this.word_array[0][this.cloudOptions.valueExpr] >
                    this.word_array[this.word_array.length - 1][this.cloudOptions.valueExpr]
                ) {
                    // Linearly map the original weight to a discrete scale from 1 to 10
                    weight =
                        Math.round(
                            (word[this.cloudOptions.valueExpr] - this.word_array[this.word_array.length - 1][this.cloudOptions.valueExpr]) /
                            (this.word_array[0][this.cloudOptions.valueExpr] -
                                this.word_array[this.word_array.length - 1][this.cloudOptions.valueExpr]) *
                            (WEIGHTS_LENGTH - 1)
                        ) + 1;
                }

                // Create a new span and insert node.
                word_span = document.createElement("span");
                word_span.className = "w" + weight;
                let colorNr = this.counter++ % this.cloudOptions.colors.length
                let color = this.cloudOptions.colors[colorNr]
                word_span.style = "color: " + color + ";"
                var textNode = document.createTextNode(word[this.cloudOptions.nameExpr]);

                word_span.appendChild(textNode);
                if (typeof word.link !== 'undefined') {
                    // Create a link
                    var word_link = document.createElement("a");
                    word_link.setAttribute('href', word.link);
                    word_link.appendChild(word_span)
                    document.getElementById("vue-tag-cloud").appendChild(word_link);
                } else {
                    //Normal creation
                    document.getElementById("vue-tag-cloud").appendChild(word_span);
                }

                if (this.cloudOptions.weights) {
                    word_span.style.fontSize = this.cloudOptions.weights[weight - 1];
                }
                word_span.onclick = () => this.tagClick(word_span, word)
                var width = word_span.offsetWidth,
                    height = word_span.offsetHeight,
                    left = this.cloudOptions.center.x - width / 2.0,
                    top = this.cloudOptions.center.y - height / 2.0;

                var word_style = word_span.style;
                word_style.position = "absolute";
                word_style.left = left + "px";
                word_style.top = top + "px";

                var step = this.cloudOptions.shape === "rectangular" ? 18.0 : 2.0,
                    aspect_ratio = this.width / this.cloudOptions.height;

                //Check if tag are hitting each other
                while (this.hitTest(word_span, this.already_placed_words)) {
                    // Default settings: elliptic spiral shape
                    radius += step;
                    angle += (index % 2 === 0 ? 1 : -1) * step;

                    left =
                        this.cloudOptions.center.x -
                        width / 2.0 +
                        radius * Math.cos(angle) * aspect_ratio;
                    top = this.cloudOptions.center.y + radius * Math.sin(angle) - height / 2.0;

                    word_style.left = left + "px";
                    word_style.top = top + "px";
                }

                // Don't render word if part of it would be outside the container
                if (
                    this.cloudOptions.removeOverflowing &&
                    (left < 0 ||
                        top < 0 ||
                        left + width > this.width ||
                        top + height > this.cloudOptions.height)
                ) {
                    word_span.remove();
                    return;
                }

                this.already_placed_words.push(word_span);
            }
        }
    }
</script>

<style lang="css">

    .vue-tag-cloud {
        font-size: 15px;
        line-height: normal;
        width: var(--cloudWidth);
        display: inline-block;
        position: relative;
        height: var(--cloudHeight);
        overflow: hidden;
        /*color: var(--color);*/
    }

        .vue-tag-cloud a {
            font-size: inherit;
            text-decoration: none;
        }

        .vue-tag-cloud span {
            padding: 0;
            cursor: pointer;
        }

            .vue-tag-cloud span.w10 {
                font-size: 550%;
                color: #00d9ff;
            }

            .vue-tag-cloud span.w9 {
                font-size: 500%;
                color: #ff008c;
            }

            .vue-tag-cloud span.w8 {
                font-size: 450%;
                color: #00a6c3;
            }

            .vue-tag-cloud span.w7 {
                font-size: 400%;
                color: #ca0370;
            }

            .vue-tag-cloud span.w6 {
                font-size: 350%;
                color: #5a6769;
            }

            .vue-tag-cloud span.w5 {
                font-size: 300%;
                color: #990054;
            }

            .vue-tag-cloud span.w4 {
                font-size: 250%;
                color: #006476;
            }

            .vue-tag-cloud span.w3 {
                font-size: 200%;
                color: #621838;
            }

            .vue-tag-cloud span.w2 {
                font-size: 150%;
                color: #00d8fe;
            }

            .vue-tag-cloud span.w1 {
                font-size: 100%;
                color: #FF4CAE;
            }

        .vue-tag-cloud a {
            color: inherit;
        }

            .vue-tag-cloud a:hover {
                color: #0df;
            }

            .vue-tag-cloud a:hover {
                color: #0cf;
            }
</style>